<div class="report-content">

	<div class="row mb-4">
		<div class="col-12">
			<ms-report-date-filter
				mode="range"
				[(startDate)]="startDate"
				[(endDate)]="endDate"
				[disabled]="isLoading()"
				(applied)="onDateChanged()" />
		</div>
	</div>

	@if (errorMessage()) {
		<div class="alert alert-danger" role="alert">
			<fa-duotone-icon icon="triangle-exclamation" class="me-2" />
			{{ errorMessage() }}
		</div>
	}

	@if (isLoading() && !report()) {
		<div class="text-center py-5">
			<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
		</div>
	}

	@if (report(); as data) {
		<div class="pl-card">
			<h5 class="pl-card-title mb-3">Profit and Loss Statement — Period Ended {{ data.endDate | orgDate: 'longDate' }}</h5>

			<!-- Revenue -->
			<div class="pl-section-bar" data-accent="info">
				<fa-duotone-icon icon="arrow-trend-up" secondaryOpacity="0.7" class="me-2 pl-section-icon" />
				Revenue
			</div>
			<table class="table table-sm pl-table mb-0">
				<tbody>
					@if (data.revenue.accounts && data.revenue.accounts.length > 0) {
						@for (row of data.revenue.accounts; track row.account.chartOfAccountId) {
							<tr>
								<td class="pl-col-account">{{ row.account.accountNumber }}</td>
								<td class="pl-col-description">
									{{ row.account.name }}
									@if (!row.account.isActive) {
										<span class="badge bg-warning-subtle text-warning-emphasis ms-1">Retired</span>
									}
								</td>
								<td class="pl-col-amount text-end">{{ formatAmount(row.amount) }}</td>
							</tr>
						}
					} @else {
						<tr>
							<td colspan="3" class="text-center text-muted py-3">No revenue activity for this period.</td>
						</tr>
					}
					<tr class="pl-total-row">
						<td class="pl-col-account"></td>
						<td class="pl-col-description text-end fw-bold">Total Revenue</td>
						<td class="pl-col-amount text-end fw-bold">{{ formatAmount(data.revenue.total) }}</td>
					</tr>
				</tbody>
			</table>

			<!-- Expenses -->
			<div class="pl-section-bar mt-4" data-accent="danger">
				<fa-duotone-icon icon="arrow-trend-down" secondaryOpacity="0.7" class="me-2 pl-section-icon" />
				Expenses
			</div>
			<table class="table table-sm pl-table mb-0">
				<tbody>
					@if (data.expenses.accounts && data.expenses.accounts.length > 0) {
						@for (row of data.expenses.accounts; track row.account.chartOfAccountId) {
							<tr>
								<td class="pl-col-account">{{ row.account.accountNumber }}</td>
								<td class="pl-col-description">
									{{ row.account.name }}
									@if (!row.account.isActive) {
										<span class="badge bg-warning-subtle text-warning-emphasis ms-1">Retired</span>
									}
								</td>
								<td class="pl-col-amount text-end">{{ formatAmount(row.amount) }}</td>
							</tr>
						}
					} @else {
						<tr>
							<td colspan="3" class="text-center text-muted py-3">No expense activity for this period.</td>
						</tr>
					}
					<tr class="pl-total-row">
						<td class="pl-col-account"></td>
						<td class="pl-col-description text-end fw-bold">Total Expenses</td>
						<td class="pl-col-amount text-end fw-bold">{{ formatAmount(data.expenses.total) }}</td>
					</tr>
				</tbody>
			</table>

			<!-- Net Income -->
			<div class="pl-section-bar mt-4" data-accent="primary">
				<fa-duotone-icon icon="scale-balanced" secondaryOpacity="0.7" class="me-2 pl-section-icon" />
				Net Income
			</div>
			<table class="table table-sm pl-table mb-0">
				<tbody>
					<tr>
						<td class="pl-col-account"></td>
						<td class="pl-col-description text-end fw-bold">Net Income</td>
						<td class="pl-col-amount text-end fw-bold"
							[class.text-danger]="data.netIncome < 0">{{ formatAmount(data.netIncome) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	}

</div>
